const accessDashboard = {

    DASHBOARD: {
        path: '/dashboard'
    },

    DASHBOARDSECOND: {
        path: '/'
    },

    PREMISE_COUNT: { name: 'Premise Count', path: '/premise-count' },
    RESIDENT_COUNT: { name: 'Resident Count', path: '/resident-count' },
    TICKET_COUNT: { name: 'Ticket Count', path: '/ticket-count' },
    NOTICE_BOARD: { name: 'Notice Board', path: '/notice-board' },
    TICKET_BOARD: { name: 'Ticket Board', path: '/ticket-board' },
    POLL_BOARD: { name: 'Poll Board', path: '/poll-board' },
    FACILITY_MANAGEMENT: { name: 'Facility Management', path: '/facility-management' },

    ADMIN_DASHBOARD: { name: 'Admin Dashboard', path: '/admin-dashboard' },
    XPRESS_ADMIN_DASHBOARD: { name: 'Xpress Admin Dashboard', path: '/xpress-admin-dashboard' },
}

export default accessDashboard;